import React from "react";
import { siteConfig } from "../utils/config";
import {
  formatPhoneNumber,
  formatPhoneNumberForTel,
} from "../utils/formatters";

// This is the server-side Navigation component with no hooks
export function NavigationServer() {
  // Static navigation with no interactive elements for SSR
  // Navigation links
  const links = [
    { path: "/how-it-works", label: "How It Works" },
    { path: "/why-us", label: "Why Us" },
    { path: "/about", label: "About" },
    { path: "/faq", label: "FAQ" },
    { path: "/contact", label: "Contact" },
  ];

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      {/* Top Contact Bar */}
      <div className="bg-accent text-dark-green-800 py-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-end items-center">
            <div className="flex items-center text-xs">
              <svg
                className="h-3 w-3 mr-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
              <span className="hidden sm:inline mr-1">Call for a quote:</span>
              <a
                href={`tel:${formatPhoneNumberForTel(siteConfig.contactPhone)}`}
                className="font-medium hover:underline"
              >
                {formatPhoneNumber(siteConfig.contactPhone)}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="bg-transparent text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20">
            {/* Website Logo */}
            <div className="flex items-center">
              <div className="flex-shrink-0 flex items-center">
                <a href="/" className="flex items-center">
                  <img
                    src="/logo.png"
                    alt="Shingle Guard Logo"
                    className="h-10 w-10"
                  />
                  <span className="ml-2 text-2xl font-medium text-white">
                    Shingle<span className="text-accent">Guard</span>
                  </span>
                </a>
              </div>

              {/* Primary Nav */}
              <div className="hidden md:ml-6 md:flex md:space-x-8">
                {links.map((link) => (
                  <a
                    key={link.path}
                    href={link.path}
                    className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-md body-text hover:border-accent hover:text-accent transition duration-150 ease-in-out"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            {/* Secondary Nav */}
            <div className="hidden md:flex md:items-center md:ml-6">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 border border-transparent text-md body-text rounded-full shadow-md bg-accent hover:bg-accent-dark hover:shadow-lg transition-all duration-300 hover:scale-105 hover:-translate-y-1"
              >
                Get Free Estimate
              </a>
            </div>

            {/* Mobile menu button */}
            <div className="flex items-center md:hidden">
              <button
                type="button"
                className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-dark-green-600 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                {/* Icon when menu is closed */}
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}
